export default {
	props: {
		isModoEditar: {
			type: Boolean,
			default: false,
		},
		atendimentoDataEditar: {
			type: Object,
			default: null,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	emits: [
		'clickCancelAtendimento',
		'clickEnviarAtendimento',
		'clickEditarAtendimento',
	],
	data() {
		return {
			modelTituloAtendimento: '',
			modelTextoAtendimento: '',
			modelDataAtendimento: null,
		}
	},
	methods: {
		onClickCloseModal() {
			this.$emit('clickCancelAtendimento')
			this.closeModal()
		},
		onSubmit() {
			let atendimentoData = {
				tituloAtendimento: this.modelTituloAtendimento,
				textoAtendimento: this.modelTextoAtendimento,
				dataAtendimento: this.modelDataAtendimento
					? this.formatToISOString(this.modelDataAtendimento)
					: null,
			}
			if (this.isModoEditar) {
				atendimentoData = {
					...atendimentoData,
					idAtendimento: this.atendimentoDataEditar.id,
				}
				this.$emit('clickEditarAtendimento', atendimentoData)
				this.clearModal()
				this.closeModal()
			} else {
				this.$emit('clickEnviarAtendimento', atendimentoData)
			}

			this.clearModal()
		},

		clearModal() {
			this.modelTituloAtendimento = ''
			this.modelTextoAtendimento = ''
			this.modelDataAtendimento = null
		},

		closeModal() {
			this.clearModal()
			modal_padrao_vue.closeModal('modal_atendimento_gerencial_sai')
		},

		formatDate(date) {
			if (this[date]) {
				const [year, month, day] = this[date].split('/')
				this.modelDataAtendimento = `${day}/${month}/${year}`
			} else {
				this.modelDataAtendimento = ''
			}
		},

		formatToISOString(dateStr) {
			const [day, month, year] = dateStr.split('/').map(Number)

			const date = new Date(Date.UTC(year, month - 1, day))

			return date.toISOString()
		},
	},

	watch: {
		modelDataAtendimento() {
			/* if(this.modelDataAtendimento){
				this.formatDate(this.modelDataAtendimento)
			} */
		},

		isModoEditar() {
			if (this.isModoEditar && this.atendimentoDataEditar) {
				this.modelTituloAtendimento =
					this.atendimentoDataEditar.titulo_atendimento
				this.modelTextoAtendimento =
					this.atendimentoDataEditar.descricao_atendimento
				this.modelDataAtendimento = GLOBAL.formatDateObject(
					new Date(this.atendimentoDataEditar.data_atendimento)
				)
			}
		},
	},

	mounted() {},

	template: html`
		<section
			class="modal--content rounded-md  flex-1 w-auto !overflow-[initial] relative"
			data-id="modal_atendimento_gerencial_sai"
			id="modal_atendimento_gerencial_sai">
			<header
				class="flex items-center justify-between px-24 pt-24 pb-16 bg-primary-pure">
				<h2 class="text-lg font-medium text-white">
					{{isModoEditar ? 'Edita': 'Novo'}} atendimento sequóia
				</h2>
				<button
					type="button"
					class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
					data-xclose="modal_padrao"
					@click="onClickCloseModal">
					<svg class="w-32 h-32">
						<use xlink:href="#icon_close"></use>
					</svg>
				</button>
			</header>
			<form
				class="flex flex-col gap-16 !p-20 w-full h-full"
				@submit.prevent="onSubmit">
				<div class="flex-1 flex flex-col w-full">
					<label class="label text-base">Titulo</label>
					<q-input
						v-model="modelTituloAtendimento"
						outlined
						type="text"
						name="titulo_atendimento"
						id="titulo_atendimento"
						placeholder="Titulo atendimento..."
						class="w-full" />
				</div>
				<div class="flex-1 flex flex-col w-full max-w-max">
					<label class="label text-base">Data atendimento</label>
					<q-input
						v-model="modelDataAtendimento"
						outlined
						placeholder="Data atendimento..."
						size="sm">
						<template v-slot:append>
							<q-icon name="event" class="cursor-pointer">
								<q-popup-proxy
									cover
									transition-show="scale"
									transition-hide="scale">
									<q-date v-model="modelDataAtendimento" mask="DD/MM/YYYY">
										<div class="row items-center justify-end">
											<q-btn v-close-popup label="Close" color="primary" flat />
										</div>
									</q-date>
								</q-popup-proxy>
							</q-icon>
						</template>
					</q-input>
				</div>
				<div class="flex-1 flex flex-col w-full">
					<label class="label text-base">Descrição</label>
					<q-input
						v-model="modelTextoAtendimento"
						outlined
						type="textarea"
						name="atendimento"
						placeholder="Conteudo do atendimento..."
						class="w-full"
						input-class="h-full !max-h-[100px]"></q-input>
				</div>
				<div class="absolute bottom-24 flex justify-evenly mt-8 w-full">
					<button
						type="button"
						class="btn secondary"
						:disabled="isLoading"
						@click="onClickCloseModal">
						Cancelar
					</button>
					<button type="submit" class="btn" :disabled="isLoading">
						{{isModoEditar ? 'Editar': 'Enviar'}}
					</button>
				</div>
			</form>
		</section>
	`,
}
